/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum FxIdDomainPushNotificationsTokensPushNotificationPlatform {
    Ios = 0,
    Android = 1,
    Web = 2,
    Steam = 3,
    WindowsStore = 4,
    Amazon = 5,
    NUMBER_unknown_default_open_api = 11184809
}


export function instanceOfFxIdDomainPushNotificationsTokensPushNotificationPlatform(value: any): boolean {
    for (const key in FxIdDomainPushNotificationsTokensPushNotificationPlatform) {
        if (Object.prototype.hasOwnProperty.call(FxIdDomainPushNotificationsTokensPushNotificationPlatform, key)) {
            if (FxIdDomainPushNotificationsTokensPushNotificationPlatform[key as keyof typeof FxIdDomainPushNotificationsTokensPushNotificationPlatform] === value) {
                return true;
            }
        }
    }
    return false;
}

export function FxIdDomainPushNotificationsTokensPushNotificationPlatformFromJSON(json: any): FxIdDomainPushNotificationsTokensPushNotificationPlatform {
    return FxIdDomainPushNotificationsTokensPushNotificationPlatformFromJSONTyped(json, false);
}

export function FxIdDomainPushNotificationsTokensPushNotificationPlatformFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainPushNotificationsTokensPushNotificationPlatform {
    return json as FxIdDomainPushNotificationsTokensPushNotificationPlatform;
}

export function FxIdDomainPushNotificationsTokensPushNotificationPlatformToJSON(value?: FxIdDomainPushNotificationsTokensPushNotificationPlatform | null): any {
    return value as any;
}

export function FxIdDomainPushNotificationsTokensPushNotificationPlatformToJSONTyped(value: any, ignoreDiscriminator: boolean): FxIdDomainPushNotificationsTokensPushNotificationPlatform {
    return value as FxIdDomainPushNotificationsTokensPushNotificationPlatform;
}

